import React from "react";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function FailurePage() {
  const navigate = useNavigate();

  return (
    <Container className="text-center py-5">
        <div className="bg-light p-4 rounded shadow">
      <h1 className="text-danger">❌ Payment Failed</h1>
      <p>Something went wrong. Please try again.</p>

      <Button variant="warning" onClick={() => navigate("/cart")}>
        Retry Payment
      </Button>
      </div>
    </Container>
  );
}